export default "__VITE_ASSET__DgBLF4rt__"